export const FORM_SUBMIT_DATE_FORMAT = "E MMM d yyyy"
